import * as React from 'react'
import { Badge } from '../ui/badge'
import { cn } from '../../lib/utils'

export interface StatusBadgeProps {
  status: 'active' | 'inactive' | 'pending' | 'error' | 'success' | 'warning'
  text?: string
  className?: string
}

const statusConfig = {
  active: {
    variant: 'default' as const,
    className: 'bg-agentela-green text-white',
    defaultText: 'Active'
  },
  inactive: {
    variant: 'secondary' as const, 
    className: 'bg-muted text-muted-foreground',
    defaultText: 'Inactive'
  },
  pending: {
    variant: 'outline' as const,
    className: 'border-agentela-gold text-agentela-gold',
    defaultText: 'Pending'
  },
  error: {
    variant: 'destructive' as const,
    className: '',
    defaultText: 'Error'
  },
  success: {
    variant: 'default' as const,
    className: 'bg-agentela-green text-white',
    defaultText: 'Success'
  },
  warning: {
    variant: 'outline' as const,
    className: 'border-agentela-orange text-agentela-orange',
    defaultText: 'Warning'
  }
}

export const StatusBadge = React.forwardRef<HTMLDivElement, StatusBadgeProps>(
  ({ status, text, className, ...props }, ref) => {
    const config = statusConfig[status]
    
    return (
      <div ref={ref} {...props}>
        <Badge
          variant={config.variant}
          className={cn(config.className, className)}
        >
          {text || config.defaultText}
        </Badge>
      </div>
    )
  }
)

StatusBadge.displayName = 'StatusBadge'
